import * as TY from 'containers/pages/keywordManagement/constants';
import { KeywordValidation } from 'containers/pages/keywordManagement/types';

type SetValidFn = (fn: (prev: KeywordValidation) => KeywordValidation) => void;

function handleKeywordField(
  e: { target: { name: string; value: string } },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: (action: { type: string; payload: any }) => void,
  setValid: SetValidFn,
) {
  const name = e.target.name.trim();
  const value = e.target.value;

  switch (name) {
    case TY.TITLE:
      dispatch({ type: TY.TITLE, payload: value });
      setValid((prev) => ({
        ...prev,
        Title: {
          isErr: !value.trim(),
          errMsg: !value.trim() ? 'Keyword is required' : '',
          canNotSave: !value.trim(),
        },
      }));
      break;

    case TY.INSTRUCTIONS:
      dispatch({ type: TY.INSTRUCTIONS, payload: value });
      break;

    default:
      dispatch({ type: name, payload: value });
      break;
  }
}

export default handleKeywordField;
